import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  uuid: null,
};

function handleRequest(
  state: State,
  { manager }: Boundaries["assignEveryoneToManager"]["request"],
): State {
  return { request: setRequestStateToPending(), uuid: manager.uuid };
}

function handleSuccess(
  state: State,
  { manager }: Boundaries["assignEveryoneToManager"]["success"],
): State {
  return { request: setRequestStateToSuccess(), uuid: manager.uuid };
}

function handleFailure(
  state: State,
  { manager }: Boundaries["assignEveryoneToManager"]["failure"],
): State {
  return { request: setRequestStateToFailure(), uuid: manager.uuid };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.assignEveryoneToManagerRequested]: handleRequest,
    [events.assignEveryoneToManagerSucceeded]: handleSuccess,
    [events.assignEveryoneToManagerFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isAssignEveryoneToManagerRequestPending({ uuid }) {
      return getState().uuid === uuid && getState().request.isPending;
    },
    isAssignEveryoneToManagerRequestSuccess({ uuid }) {
      return getState().uuid === uuid && getState().request.isSuccessful;
    },
    isAssignEveryoneToManagerRequestFailure({ uuid }) {
      return getState().uuid === uuid && getState().request.isFailure;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
